<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header"></div>

        <div class="modal__content modal__content--survey-answers">
            <div class="panel__list">
                <div class="panel__list__item" v-for="(question, index) in questions" :key="question.id">
                    <h3>{{question.description}} {{question.required ? '*' : ''}}</h3>
                    <component :is="`survey-question-${question.type.value ? question.type.value : question.type }-form`" v-model="questions[index]" :locked="true" />
                </div>
            </div>
        </div>

        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.close')}}</button>
            </div>
        </div>
    </modal-wrapper>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import SurveyQuestionLikertForm from '@/components/forms/survey/SurveyQuestionLikertForm';
    import SurveyQuestionMultipleForm from '@/components/forms/survey/SurveyQuestionMultipleForm';
    import SurveyQuestionOpenForm from '@/components/forms/survey/SurveyQuestionOpenForm';
    import SurveyQuestionScaleForm from '@/components/forms/survey/SurveyQuestionScaleForm';

    @Component({
        components: {
            SurveyQuestionLikertForm,
            SurveyQuestionMultipleForm,
            SurveyQuestionOpenForm,
            SurveyQuestionScaleForm,
        }
    })
    export default class SurveyAnswersModal extends Vue {
        name = 'survey-answers-modal';
        survey = {};
        questions = [];

        beforeOpen(event) {
            if (event.params && event.params.survey) {
                this.survey = event.params.survey;
                this.questions = this.survey.survey_template.questions.map(q => {
                    const answerObj = this.survey.answers.find(a => a.survey_question_id === q.id);
                    const answer = answerObj ? answerObj.answer : '';
                    return { ...q, answer: answer };
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/SurveyAnswersModal.vue